module.exports = "<div class=\"photo-for-list-form\" [formGroup]=\"form\">\r\n  <atn-image-input formControlName=\"image\" size=\"s\"></atn-image-input>\r\n\r\n  <mat-form-field>\r\n    <input\r\n      matInput\r\n      formControlName=\"alt\"\r\n      placeholder=\"Texto Alternativo\"\r\n    >\r\n    <atn-current-locale-code matSuffix></atn-current-locale-code>\r\n  </mat-form-field>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-photo-for-list-form/product-photo-for-list-form.component.html
// module id = ./libs/atenea-cms-brand/src/products/product-photo-for-list-form/product-photo-for-list-form.component.html
// module chunks = main